import {Component, OnInit} from '@angular/core';
import {ProductSearchPage, RoutingService} from '@spartacus/core';
import {DcpProductService} from '@app/product/services/dcp-product.service';
import {DcpSearchProductComponent} from '@app/search/dcp-search-product/dcp-search-product.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'dcp-recently-added',
  templateUrl: './recently-added.component.html',
  styleUrls: [
    './recently-added.component.scss',
    '../../../styles/_tile.scss',
  ],
  providers: [DcpSearchProductComponent]
})

export class RecentlyAddedComponent implements OnInit {
  productSearchPage$: Observable<ProductSearchPage>;

  constructor(protected routingService: RoutingService,
              private dcpProductService: DcpProductService) {
  }

  ngOnInit() {
    this.productSearchPage$ = this.dcpProductService.fetchRecentlyAddedProducts();
  }

  launchSearchResult(): void {
    this.routingService.go({
        cxRoute: 'search',
        params: {
          query: '',
        },
      },
      {
        queryParams: {
          sortCode: 'createdat-desc'
        }
      }
    );
  }
}
